import React, { createContext, useContext, useState } from "react";

import { AplicacaoService } from "../services";

export const ContainerContext = createContext({});

export function ContainerContextProvider({ children }) {
    const [desktopMenuAberto, setDesktopMenuAberto] = useState(AplicacaoService.getDesktopMenuAberto());
    const [mobileMenuAberto, setMobileMenuAberto] = useState(false);

    function toggleDesktopMenu() {
        setDesktopMenuAberto(AplicacaoService.setDesktopMenuAberto(!desktopMenuAberto))
    }

    function toggleMobileMenuAberto() {
        setMobileMenuAberto(!mobileMenuAberto);
        if (!desktopMenuAberto)
            toggleDesktopMenu();
    }

    return (
        <ContainerContext.Provider
            value={{
                desktopMenuAberto,
                mobileMenuAberto,

                toggleDesktopMenu,
                toggleMobileMenuAberto
            }}>
            {children}
        </ContainerContext.Provider>
    )
}

export const useContainerContext = () => {
    return useContext(ContainerContext);
}
